// extracted by mini-css-extract-plugin
module.exports = {"container":"featuredStyles-module--container--2ztOC","content":"featuredStyles-module--content--37Be1","title":"featuredStyles-module--title--3ycRJ"};